import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExclamation = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16.686 0h-1.41c-1.024 0-1.854.812-1.854 1.81v20.125c0 .997.826 1.805 1.847 1.805h1.408c1.024 0 1.854-.812 1.856-1.81V1.805A1.825 1.825 0 0 0 16.686.002zm.047 27.429h-1.411c-1.024 0-1.855.812-1.855 1.81v.958c0 .997.827 1.803 1.847 1.803h1.41c1.024 0 1.852-.81 1.854-1.808v-.96a1.825 1.825 0 0 0-1.847-1.803z" /></svg>;
export default SvgExclamation;